import { render } from "./About.vue?vue&type=template&id=df278624"
const script = {}

import exportComponent from "/home/josearpaia/Documentos/etyalab/cositas-en-vue/api-banderas-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__